import { Outlet } from 'react-router-dom';
import { RouteSegments } from '@cbridge-packages/routing-client-admin';
import { UserSettingsSection } from '@cbridge-packages/user-settings';
import { SidebarNavigationDrawer } from '@cbridge-modules/sidebar';
import { ConfigSidebarFooter } from './ConfigSidebarFooter/ConfigSidebarFooter';
import { useConfigNavigationItems } from './useConfigNavigationItems/useConfigNavigationItems';

export function ConfigLayout() {
  const configNavigation = useConfigNavigationItems();

  return (
    <>
      <SidebarNavigationDrawer
        defaultSidebarCollapsed={true}
        isCollapsible={true}
        settingsKey={UserSettingsSection.Config}
        isResizable={true}
        navigation={configNavigation}
        navigationBasePath={`/${RouteSegments.Root.Config}`}
        slots={{
          sidebarFooter: ConfigSidebarFooter,
        }}
      />

      <Outlet />
    </>
  );
}
